<template>
  <div class="menu_container">
    <n-menu
      :key="uuidv4()"
      v-model:value="queryName"
      class="menu"
      :inverted="false"
      :icon-size="computeIconSize"
      :indent="32"
      :root-indent="10"
      :options="menuOptions"
      :default-expand-all="expandAllStatus"
      :collapsed="collapsed"
      :collapsed-width="70"
      :collapsed-icon-size="22"
    />
  </div>

  <n-popover :theme-overrides="menuThemePopover" trigger="click" :x="0" :show-arrow="false" placement="right-end">
    <template #trigger>
      <div class="menu_footer">
        <svg-icon class="contact_icon" icon-name="contact" icon-class="contact" />
        <span v-if="!collapsed"> Contact Us & Quick Links</span>
      </div>
    </template>
    <div class="popover_content">
      <head-title title="Contact Us"></head-title>
      <div class="footer_items">
        <div class="footer_item_text">
          <a href="mailto:DataTransformationOfficeCN@bmw.com" rel="nofollow">DataTransformationOfficeCN@bmw.com</a>
        </div>
        <div class="footer_item_text">
          <a href="mailto:DataTransformationOfficeCN@bmw-brilliance.cn" rel="nofollow"
            >DataTransformationOfficeCN@bmw-brilliance.cn</a
          >
        </div>
        <div class="footer_item_text">
          <a
            href="https://atc.bmw-brilliance.cn/confluence/pages/viewpage.action?pageId=854798341"
            target="_blank"
            rel="noopener"
            >EDM Support</a
          >
        </div>
      </div>
      <div class="content_quick">
        <head-title title="Quick Links"></head-title>
        <div class="footer_items">
          <div class="footer_item_text">
            <a rel="noopener" href="https://atc.bmwgroup.net/confluence/x/ldjNGg" target="_blank">
              DTO Global Confluence (If there is any issue with logging in,please contact us.)</a
            >
          </div>
          <div class="footer_item_text">
            <a rel="noopener" href="https://dts.bmw.com.cn/" target="_blank">China Data Tranasformation Space(DTS)</a>
          </div>
        </div>
      </div>
    </div>
  </n-popover>
</template>

<script lang="ts" setup>
import { h, computed, watch, ref } from 'vue';
import { useRoute, useRouter, RouterLink } from 'vue-router';
import { v4 as uuidv4 } from 'uuid';
import { NIcon, NMenu, NPopover, NEllipsis } from 'naive-ui';
import { useStore } from 'vuex';

import HeadTitle from '@/components/HeadTitle.vue';
import SvgIcon from '@/components/SvgIcon.vue';

const route: any = useRoute();
const router: any = useRouter();
const store = useStore();
const props = defineProps({
  collapsed: {
    type: Boolean,
    default: true,
  },
});

// const menuOptions = ref([])

const routeChildObj: any = {
  '/datasetAnalysis': '/dataset',
  '/metaModeldetail': '/metaModel',
};
const queryName = computed(() => {
  return routeChildObj[route.name] || route.name;
});

const expandAllStatus = computed(() => {
  return route.meta.ownType === 'MyWorkspace' ? false : true;
});

const menuThemePopover = {
  space: '0',
};

const computeIconSize = computed(() => {
  const calcSize = parseInt(getComputedStyle(window.document.documentElement)['font-size'], 10);
  return (20 / 192) * calcSize;
});

// 已知某树节点查找树的唯一路径
const findPath = (node: any, children: any) => {
  let res: any = [];
  let traverse = (targetId: any, pathList: any, children: any) => {
    if (!children.length) return;

    for (let item of children) {
      pathList.push(item.id);

      if (item.id === targetId) {
        res = [...pathList];
        return;
      }
      traverse(targetId, pathList, item.children);
      pathList.pop();
    }
  };

  node?.id && traverse(node.id, [], children);

  return res || [];
};

const setCurrentTab = (item?: any) => {
  const path = findPath(item, store.getters.priList);

  store.commit('user/SET_TAB', path);
};

const renderIcon = (icon: string) => {
  return () =>
    h(NIcon, null, {
      default: () => h(SvgIcon, { iconName: icon, iconClass: icon }),
    });
};

const renderTree = (siderData: any[], level: number) => {
  const rendertree: any = siderData.map((item) => {
    const obj = {
      label: () => {
        const { type, label, name } = item;
        if (type === 'router') {
          // 做一下路由合法性的判断，否则会报错
          const allRouteNames = router.getRoutes().map((it: any) => it.name);
          const isExist = allRouteNames.includes(name);
          return h(
            NEllipsis,
            {
              themeOverrides: {
                textColor: '#fff',
              },
              tooltip: {
                placement: 'right',
              },
            },
            {
              default: () =>
                isExist
                  ? h(
                      RouterLink,
                      {
                        // exact: true,
                        to: {
                          name,
                        },
                        onClick: () => {
                          setCurrentTab(item);
                        },
                      },
                      label
                    )
                  : h(
                      'a',
                      {
                        href: window.origin + '/#/view/' + name,
                        onClick: () => {
                          setCurrentTab(item);
                        },
                      },
                      name
                    ),
              tooltip: () => label,
            }
          );
        }
        return h(NEllipsis, null, { default: () => label });
      },

      key: item.key,
      name: item.name,
      icon: item.icon ? renderIcon(item.icon) : null,
    };
    if (item.children.length > 0) {
      obj.children = renderTree(item.children, level + 1);
    } else if (level === 1 && props.collapsed) {
      obj.children = [];
    }
    return obj;
  });
  return rendertree;
};

const mapMenu: any = {
  Metadata: 'metadataManage',
  MyWorkspace: 'MyWorkspace',
  dataQuality: 'dataquality',
  kpiCatalog: 'KPICatalog',
  Operations: 'Operations',
  dataStandards: 'dataStandards',
  MasterData: 'MasterData',
  useCaseContent: 'useCaseContent',
  aiGovernance: 'aiGovernance',
};

const getMenuList = () => {
  const menuList = store.getters.priList || [];
  return (menuList.find((item: any) => item.icon === mapMenu[route.meta.ownType]) || {}).children || [];
};

const menuOptions = ref([]);

watch(
  () => router.currentRoute.value.path,
  (newValue) => {
    const currentMenu = getMenuList();
    setCurrentTab(currentMenu?.[0]);
    if (newValue == '/dataGovernace' || newValue == '/') {
      menuOptions.value = [];
    } else {
      menuOptions.value = renderTree(currentMenu, 1);
    }
  },
  { immediate: true }
);
watch(
  () => props.collapsed,
  () => {
    const currentMenu = getMenuList();
    menuOptions.value = renderTree(currentMenu, 1);
  }
);
</script>

<style lang="scss" scoped>
.logo_container {
  width: 100%;
  height: 63px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f2f2f2;

  .logo_bg {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .logo_icon {
    width: 74px;
    height: 20px;
    background-image: url('../assets/edm_logo_icon.png');
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
  }

  .logo_text {
    font-size: 14px;
    color: #666;
    font-weight: 700;
    user-select: none;
  }
}

.menu_footer {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  color: #262626;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  justify-content: center;
  border-top: 1px solid #f2f2f2;
  cursor: pointer;
  background-color: #fff;
  z-index: 10;
}

.head_logo_icon {
  font-size: 30px;
}

.contact_icon {
  margin-right: 8px;
  font-size: 18px;
}

.popover_content {
  padding: 22px;

  .header {
    font-weight: bold;
  }
}

.footer_items {
  margin-top: 10px;
}

.footer_item_text a {
  color: #572df3;
  line-height: 16px;
  font-size: 10px;
}

.content_quick {
  margin-top: 30px;
}

.menu_container {
  height: calc(100vh - 140px);
  overflow-y: auto;
  display: flex;
  align-content: center;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(50, 50, 50, 0.3);
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 1em;
  }
}
.menu {
  overflow-y: auto;
}
</style>
<style>
.n-popover-shared {
  margin-left: 0px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
}
</style>
